<template>
    <nav class="blue darken-3 nav-extended">
        <div class="nav-wrapper center">
            <router-link to="/" class="kfbbrand-logo center" tag="a">KBO Fantasy Baseball</router-link>
        </div>
        <div class="nav-content">
          <ul class="tabs tabs-transparent">
            <li class="tab" v-show="user">
                <router-link to="/" tag="a" :class="homeActive">Home</router-link>
            </li>
            <li class="tab" v-show="user">
                <router-link to="/league" tag="a" :class="leagueActive">League</router-link>
            </li>
            <li class="tab" v-show="user">
                <router-link to="/players" tag="a" :class="playersActive">Players</router-link>
            </li>
            <li class="tab" >
                <router-link to="/rules" tag="a" :class="rulesActive">Rules</router-link>
            </li>
            <li class="tab" v-show="!user">
                <router-link to="/login" tag="a" :class="loginActive">Login</router-link>
            </li>
            <li class="tab" v-show="user">
                <a @click="signoutButtonPressed">Logout</a>
            </li>
          </ul>
        </div>
    </nav>
</template>

<script>
import firebase from "firebase";
export default {
    data() {
        return {
            user: null
        };
    },
    created() {
        firebase.auth().onAuthStateChanged(user => {
            this.user = user;
        });
    },
    methods: {
        signoutButtonPressed(e) {
            e.stopPropagation();
            firebase.auth().signOut();
            this.$router.push({ name: "Login" });
        }
    },
    props: {
        activeTab: {
            type: String, // not 'string'
            required: true,
            default: "none"
        }
    },
    computed :{
        loginActive() {return (this.activeTab=="login" ? "active" : "")},
        homeActive() {return (this.activeTab=="home" ? "active" : "")},
        leagueActive() {return (this.activeTab=="league" ? "active" : "")},
        playersActive() {return (this.activeTab=="players" ? "active" : "")},
        rulesActive() {return (this.activeTab=="rules" ? "active" : "")},
    }
};
</script>




// WEBPACK FOOTER //
// src/components/NavBar.vue